import { Component, Injectable, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'delete-person-workspace-modal',
  templateUrl: 'delete-person-workspace-modal.component.html',
  styleUrls: ['delete-person-workspace-modal.component.scss'],
  standalone: false
})
export class DeletePersonWorkspaceModalComponent {
  textMatcherValue: string = '';

  constructor(
    public dialogRef: MatDialogRef<DeletePersonWorkspaceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  isRemoveButtonDisabled() {
    return this.textMatcherValue != 'REMOVE';
  }

  removeButtonClicked() {
    return { remove: true };
  }

  cancelButtonClicked() {
    return { remove: false };
  }
}
